import { createContext, useContext, type ReactNode } from 'react';
import type { ViewContextStore } from '../hooks/useViewContext';
import type { RequestViewContext, ScreenId } from '../lib/viewContext';

/**
 * The view context store and what the current screen sends (Phase B step
 * 1). OpsCommand owns the store; any screen or control reads it here
 * instead of taking the parts as props (the context bar of step 3 does).
 */
export type ViewContextValue = {
  store: ViewContextStore;
  screen: ScreenId;
  /** The full context of the current screen, as every request sends it. */
  request: RequestViewContext;
};

const ViewContextReact = createContext<ViewContextValue | null>(null);

export function ViewContextProvider({
  value,
  children,
}: {
  value: ViewContextValue;
  children: ReactNode;
}) {
  return <ViewContextReact.Provider value={value}>{children}</ViewContextReact.Provider>;
}

/** The view context, or null outside OpsCommand (isolated component tests). */
export function useViewContext(): ViewContextValue | null {
  return useContext(ViewContextReact);
}
